export const categories = [
  {
    id: 2,

    cat: "Aarika",
  },
  {
    id: 3,

    cat: "Van Heusen",
  },
  {
    id: 4,

    cat: "Harpa",
  },
  {
    id: 5,

    cat: "W",
  },
  {
    id: 6,

    cat: "Biba",
  },
  {
    id: 7,

    cat: "Allen Solly",
  },
];
